// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clients-list .muted {
  color: #64748b;
  font-size: 0.8rem;
  margin-top: 2px;
}
.clients-list .p-datatable {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);
}
.clients-list .p-datatable-thead > tr > th {
  background: #f9fafb;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #e5e7eb;
}
.clients-list .p-datatable-tbody > tr > td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.clients-list .p-datatable-tbody > tr:last-child > td {
  border-bottom: 0;
}
.clients-list tr.clickable {
  cursor: pointer;
  transition: background 0.12s;
}
.clients-list tr.clickable:hover {
  background: #f0fdfa;
}
.clients-list .actions-col {
  width: 110px;
  text-align: right;
  white-space: nowrap;
}
.clients-list .actions-col .p-button + .p-button {
  margin-left: 0.4rem;
}
.clients-list .empty {
  text-align: center;
  padding: 2.5rem 1rem !important;
  color: #64748b;
}
.who {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}
.who .avatar {
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ccfbf1;
  color: #0f766e;
  font-weight: 700;
  font-size: 0.85rem;
}
.who .name {
  font-weight: 600;
  color: #0f172a;
}
.who .muted {
  color: #64748b;
  font-size: 0.8rem;
  margin-top: 2px;
}
.who.big {
  gap: 1rem;
  margin-bottom: 1.2rem;
}
.who.big .avatar {
  width: 56px;
  height: 56px;
  font-size: 1.1rem;
}
.who.big .name {
  font-size: 1.15rem;
  margin-bottom: 4px;
}
.clients-list td i.pi {
  margin-right: 6px;
  color: #94a3b8;
}
.client-view .facts {
  list-style: none;
  margin: 0 0 1.4rem;
  padding: 0;
}
.client-view .facts li {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  padding: 0.7rem 0;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}
.client-view .facts li i {
  margin-top: 3px;
  color: #94a3b8;
}
.client-view .facts li a {
  color: #0f766e;
  text-decoration: none;
}
.client-view .facts li a:hover {
  text-decoration: underline;
}
@media (max-width: 768px) {
  .clients-list th:nth-child(3),
  .clients-list td:nth-child(3) {
    display: none;
  }
}
/*# sourceMappingURL=manage-clients.component.css.map */`, "",{"version":3,"sources":["webpack://./manage-clients.component.less","webpack://./src/app/clients/manage-clients/manage-clients.component.less"],"names":[],"mappings":"AAEA;EAEI,cAAA;EACA,iBAAA;EACA,eAAA;ACFJ;ADFA;EAQI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mDAAA;ACHJ;ADTA;EAgBI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gCAAA;ACJJ;ADnBA;EA2BI,oBAAA;EACA,gCAAA;EACA,sBAAA;ACLJ;ADxBA;EAiCI,gBAAA;ACNJ;AD3BA;EAqCI,eAAA;EACA,4BAAA;ACPJ;ADSI;EACE,mBAAA;ACPN;ADlCA;EA8CI,YAAA;EACA,iBAAA;EACA,mBAAA;ACTJ;ADvCA;EAmDM,mBAAA;ACTN;AD1CA;EAwDI,kBAAA;EACA,+BAAA;EACA,cAAA;ACXJ;ADeA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;ACbF;ADUA;EAMI,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ACbJ;ADHA;EAoBI,gBAAA;EACA,cAAA;ACdJ;ADPA;EAyBI,cAAA;EACA,iBAAA;EACA,eAAA;ACfJ;ADkBE;EACE,SAAA;EACA,qBAAA;AChBJ;ADcE;EAKI,WAAA;EACA,YAAA;EACA,iBAAA;AChBN;ADSE;EAWI,kBAAA;EACA,kBAAA;ACjBN;ADsBA;EACE,iBAAA;EACA,cAAA;ACpBF;ADuBA;EAEI,gBAAA;EACA,kBAAA;EACA,UAAA;ACtBJ;ADkBA;EAOM,aAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,gCAAA;EACA,cAAA;ACtBN;ADUA;EAeQ,eAAA;EACA,cAAA;ACtBR;ADMA;EAoBQ,cAAA;EACA,qBAAA;ACvBR;ADyBQ;EACE,0BAAA;ACvBV;AD8BA;EACE;;IAEE,aAAA;EC5BF;AACF;AACA,uDAAuD","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n.clients-list {\n  .muted {\n    color: #64748b;\n    font-size: 0.8rem;\n    margin-top: 2px;\n  }\n\n  .p-datatable {\n    background: @white;\n    border: 1px solid #e5e7eb;\n    border-radius: 14px;\n    overflow: hidden;\n    box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n  }\n\n  .p-datatable-thead > tr > th {\n    background: #f9fafb;\n    color: #64748b;\n    font-size: 0.72rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    padding: 0.85rem 1rem;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  .p-datatable-tbody > tr > td {\n    padding: 0.9rem 1rem;\n    border-bottom: 1px solid #f1f5f9;\n    vertical-align: middle;\n  }\n\n  .p-datatable-tbody > tr:last-child > td {\n    border-bottom: 0;\n  }\n\n  tr.clickable {\n    cursor: pointer;\n    transition: background 0.12s;\n\n    &:hover {\n      background: #f0fdfa;\n    }\n  }\n\n  .actions-col {\n    width: 110px;\n    text-align: right;\n    white-space: nowrap;\n\n    .p-button + .p-button {\n      margin-left: 0.4rem;\n    }\n  }\n\n  .empty {\n    text-align: center;\n    padding: 2.5rem 1rem !important;\n    color: #64748b;\n  }\n}\n\n.who {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n\n  .avatar {\n    flex: none;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: #ccfbf1;\n    color: #0f766e;\n    font-weight: 700;\n    font-size: 0.85rem;\n  }\n\n  .name {\n    font-weight: 600;\n    color: #0f172a;\n  }\n\n  .muted {\n    color: #64748b;\n    font-size: 0.8rem;\n    margin-top: 2px;\n  }\n\n  &.big {\n    gap: 1rem;\n    margin-bottom: 1.2rem;\n\n    .avatar {\n      width: 56px;\n      height: 56px;\n      font-size: 1.1rem;\n    }\n\n    .name {\n      font-size: 1.15rem;\n      margin-bottom: 4px;\n    }\n  }\n}\n\n.clients-list td i.pi {\n  margin-right: 6px;\n  color: #94a3b8;\n}\n\n.client-view {\n  .facts {\n    list-style: none;\n    margin: 0 0 1.4rem;\n    padding: 0;\n\n    li {\n      display: flex;\n      align-items: flex-start;\n      gap: 0.8rem;\n      padding: 0.7rem 0;\n      border-bottom: 1px solid #f1f5f9;\n      color: #334155;\n\n      i {\n        margin-top: 3px;\n        color: #94a3b8;\n      }\n\n      a {\n        color: #0f766e;\n        text-decoration: none;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .clients-list th:nth-child(3),\n  .clients-list td:nth-child(3) {\n    display: none;\n  }\n}\n",".clients-list .muted {\n  color: #64748b;\n  font-size: 0.8rem;\n  margin-top: 2px;\n}\n.clients-list .p-datatable {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n}\n.clients-list .p-datatable-thead > tr > th {\n  background: #f9fafb;\n  color: #64748b;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n.clients-list .p-datatable-tbody > tr > td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n.clients-list .p-datatable-tbody > tr:last-child > td {\n  border-bottom: 0;\n}\n.clients-list tr.clickable {\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.clients-list tr.clickable:hover {\n  background: #f0fdfa;\n}\n.clients-list .actions-col {\n  width: 110px;\n  text-align: right;\n  white-space: nowrap;\n}\n.clients-list .actions-col .p-button + .p-button {\n  margin-left: 0.4rem;\n}\n.clients-list .empty {\n  text-align: center;\n  padding: 2.5rem 1rem !important;\n  color: #64748b;\n}\n.who {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n}\n.who .avatar {\n  flex: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #ccfbf1;\n  color: #0f766e;\n  font-weight: 700;\n  font-size: 0.85rem;\n}\n.who .name {\n  font-weight: 600;\n  color: #0f172a;\n}\n.who .muted {\n  color: #64748b;\n  font-size: 0.8rem;\n  margin-top: 2px;\n}\n.who.big {\n  gap: 1rem;\n  margin-bottom: 1.2rem;\n}\n.who.big .avatar {\n  width: 56px;\n  height: 56px;\n  font-size: 1.1rem;\n}\n.who.big .name {\n  font-size: 1.15rem;\n  margin-bottom: 4px;\n}\n.clients-list td i.pi {\n  margin-right: 6px;\n  color: #94a3b8;\n}\n.client-view .facts {\n  list-style: none;\n  margin: 0 0 1.4rem;\n  padding: 0;\n}\n.client-view .facts li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.8rem;\n  padding: 0.7rem 0;\n  border-bottom: 1px solid #f1f5f9;\n  color: #334155;\n}\n.client-view .facts li i {\n  margin-top: 3px;\n  color: #94a3b8;\n}\n.client-view .facts li a {\n  color: #0f766e;\n  text-decoration: none;\n}\n.client-view .facts li a:hover {\n  text-decoration: underline;\n}\n@media (max-width: 768px) {\n  .clients-list th:nth-child(3),\n  .clients-list td:nth-child(3) {\n    display: none;\n  }\n}\n/*# sourceMappingURL=manage-clients.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
